var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplecheckout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_731985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.4967 0C25.3642 0.147499 22.8717 1.51249 21.4192 3.28998C20.0942 4.90247 19.0042 7.29746 19.4292 9.62494C21.7592 9.69744 24.1667 8.29995 25.5617 6.49246C26.8667 4.80997 27.8542 2.42999 27.4967 0Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.9229 13.4198C33.8754 10.8523 30.998 9.3623 28.2805 9.3623C24.693 9.3623 23.1755 11.0798 20.683 11.0798C18.113 11.0798 16.1605 9.3673 13.0581 9.3673C10.0106 9.3673 6.7656 11.2298 4.70811 14.4148C1.81563 18.8997 2.31063 27.3322 6.9981 34.5147C8.67559 37.0846 10.9156 39.9746 13.8456 39.9996C16.453 40.0246 17.188 38.3271 20.7205 38.3096C24.253 38.2896 24.923 40.0221 27.5255 39.9946C30.458 39.9721 32.8205 36.7696 34.4979 34.1997C35.7004 32.3572 36.1479 31.4297 37.0804 29.3497C30.298 26.7672 29.2105 17.1223 35.9229 13.4198Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplecheckout);
export default __webpack_public_path__ + "static/media/applecheckout.c868cf5251d6b76620900bb7ce30afde.svg";
export { ForwardRef as ReactComponent };